import miguelPic from "@/public/images/artists/miguel.jpg";
import { Artist } from "@/types/types";

export const miguel = {
  id: "231",
  name: "Miguel",
  image: miguelPic,
  description: `Miguel’s voice has a refined mid-range resonance, carrying a sensitivity that reflects the passion of Latin culture. His vocal style combines ease with energy, excelling in genres like Latin trap, reggaeton, and other modern fusion styles that demand rhythmic precision.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmiguel-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Latin", "Unprocessed", "Pop", "Dance"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 50,
        high: 65,
      },
      sweetSpot: 57,
    },
  },
} as const satisfies Artist;
